import orginJSONP from 'jsonp'

var aMapKey = '35da3c77f5d6952d5bc8bf619ae855bb'// 个人-朗
// var aMapKey = 'a5d227c27d964e39f61582e82c36fa4b'//个人-冬哥
var yiliuMapKey = '672a0b0ad3864a331c9e2f2e62e45693'// 易流平台

function jsonp (url, data, option) {
  url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
  return new Promise((resolve, reject) => {
    orginJSONP(url, option, (err, data) => {
      if (!err) {
        resolve(data)
      } else {
        reject(err)
      }
    })
  })
}

function param (data) {
  let url = ''
  for (var k in data) {
    let values = data[k] !== undefined ? data[k] : ''
    url += '&${k}=${encodeURIComponent(values)}'
  }
  return url ? url.substring(1) : ''
}

export function reqSearchPolygon (keyword, lefttop, rightbottom, callBack) {
  // jsonp('http://restapi.amap.com/v3/place/polygon?keywords=' + keyword + '&polygon=' + '108.63119144368842%2C24.4445891838384%3B113.90462894368586%2C22.08048859524593%3B' + lefttop.lon + '%2C' + lefttop.lat + '%3B' + rightbottom.lon + '%2C' + rightbottom.lat + '&page=1&offset=8&key=' + aMapKey, null).then(data => {
  jsonp('http://restapi.amap.com/v3/place/polygon?keywords=' + keyword + '&polygon=' + '109.45241947103177%2C22.280140330064626%3B109.45241947103177%2C24.248156551154814%3B110.08340091634251%2C24.248156551154814%3B110.08340091634251%2C22.280140330064626%3B109.45241947103177%2C22.280140330064626%3B109.45241947103177%2C3%3B135%2C3%3B135%2C54%3B73%2C54%3B73%2C3%3B109.45241947103177%2C3%3B109.45241947103177%2C22.280140330064626' + '&page=1&offset=8&key=' + aMapKey, null).then(data => {
  // console.log(data)
    if (callBack) {
      callBack(data)
    }
  }).catch(err => {
    console.log(err)
  })
}

export function reqSearchPOI (query, pos, callBack) {
  jsonp('https://restapi.amap.com/v3/assistant/inputtips?keywords=' + query + '&location=' + pos.lon + '%2C' + pos.lat + '&key=' + aMapKey, null).then(data => {
  // console.log(data)
    if (callBack) {
      callBack(data)
    }
  }).catch(err => {
    console.log(err)
  })
}

export function reqGDReverseGeocoderDetail (lat, lon, callBack) {
  // 易流平台
  jsonp('https://restapi.amap.com/v3/geocode/regeo?&key=' + yiliuMapKey + '&s=rsv3&language=zh_cn&location=' + lon + ',' + lat + '&jscode=118e8fc46ede1364657c05b5f01d1e42&radius=1000&platform=JS&logversion=2.0&appname=https%3A%2F%2Fwebgispro.e6yun.com%2Fmap%2F%23%2Fmonitor', null).then(data => {
    // 个人
  // jsonp('https://restapi.amap.com/v3/geocode/regeo?output=JSON&location=' + lon + ',' + lat + '&key=' + aMapKey, null).then(data => {
    // console.log(data)
    data = data.regeocode
    if (callBack) {
      callBack(data)
      return callBack
    }
  }).catch(err => {
    console.log(err)
  })
}
